import { render } from "./PersonSearchForm.vue?vue&type=template&id=2aaede06&scoped=true&lang=pug"
import script from "./PersonSearchForm.vue?vue&type=script&lang=js"
export * from "./PersonSearchForm.vue?vue&type=script&lang=js"

import "./PersonSearchForm.vue?vue&type=style&index=0&id=2aaede06&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aaede06"]])

export default __exports__